import { MOBILE_QUERY } from "@/utils/breakpoints";

// Le fallback doit retourner la MÊME valeur sur le serveur ET côté client à
// l'hydration, sinon Vue détecte un mismatch (UA mobile côté serveur → mobile,
// `false` côté client → desktop). On lit l'UA via header côté serveur et via
// `navigator.userAgent` côté client.
function detectMobileUA(): boolean {
  const ua = import.meta.server
    ? (useRequestHeaders(["user-agent"])["user-agent"] ?? "")
    : (typeof navigator !== "undefined" ? navigator.userAgent : "");
  return /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
}

export function useIsMobile(query: string = MOBILE_QUERY) {
  return useMediaQuery(query, { shared: true, serverFallback: detectMobileUA });
}
